var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDivider = function SvgDivider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1228 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#CBDCED",
    strokeDasharray: "4 4",
    strokeLinecap: "square",
    d: "M.5 4.5h1227"
  })));
};
export default SvgDivider;